<template>
  <div>
    <div class="nav">
      <div class="main">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>立体教材</el-breadcrumb-item>
          <el-breadcrumb-item>立体教材详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="main">
      <div class="centest">
        <div class="testTit">第一章节：章节名称</div>
        <div
          class="testTip"
        >本章通过单选、多选题、判断、填空和简答题对学习效果进行测试，共10分，其中单选题1道，每道题2分，多选题1道，每道题3分， 判断题1道，每道题2分，简答题1道，每道题3分。注意截止提交时间为2018年12月21日23：00.</div>

        <div>
          <div v-if="singlesshow==true">
            <div v-for="(item,index) in single" :key="index">
              <div class="Tit">十万个为什么</div>
              <el-radio-group v-model="ruleForm.single">
                <el-radio label="a">{{item.optiona}}</el-radio>
                <el-radio label="b">{{item.optionb}}</el-radio>
                <el-radio label="c">{{item.optionc}}</el-radio>
                <el-radio label="d">{{item.optiond}}</el-radio>
              </el-radio-group>
              <div class="send" @click="getTestItem(item.fid,ruleForm.single)">下一题</div>
            </div>
          </div>
        </div>
        <div v-if="multipleshow == true">
          <div v-for="(item,index) in multiple" :key="index">
            <div class="Tit">{{item.examTitle}}</div>
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="A" name="type">{{item.optiona}}</el-checkbox>
              <el-checkbox label="B" name="type">{{item.optionb}}</el-checkbox>
              <el-checkbox label="C" name="type">{{item.optionc}}</el-checkbox>
              <el-checkbox label="D" name="type">{{item.optiond}}</el-checkbox>
              <el-checkbox label="E" name="type" v-if="item.optione !== null">{{item.optione}}</el-checkbox>
            </el-checkbox-group>
            <div class="send" @click="getTestItem(item.fid,ruleForm.type)">下一题</div>
          </div>
        </div>
        <div v-if="judgeshow ==true">
          <div v-for="(item,index) in judge" :key="index">
            <div class="Tit">{{item.examTitle}}</div>
            <el-radio-group label v-model="ruleForm.judge">
              <el-radio label="A">
                <!-- {{item.optiona}} -->
                <span class="icoText">A.</span>
                <!-- <i class="el-icon-check icoLogo"></i> -->
                <img src="../../assets/img/right.png" alt class="icoLogo" />
              </el-radio>
              <el-radio label="B">
                <!-- {{item.optionb}} -->
                <span class="icoText">B.</span>
                <!-- <i class="el-icon-close"></i> -->
                <img src="../../assets/img/false.png" alt class="icoLogo" />
              </el-radio>
            </el-radio-group>
            <div class="send" @click="getTestItem(item.fid,ruleForm.judge)">下一题</div>
          </div>
        </div>
        <div v-if="blanksshow== true">
          <div v-for="(item,index) in blanks" :key="index">
            <div class="Tit">{{item.examTitle}}</div>
            <el-input v-model="ruleForm.blanks" placeholder="请输入正确答案"></el-input>
            <div class="send" @click="getTestItem(item.fid,ruleForm.blanks)">下一题</div>
          </div>
        </div>
        <div v-if="shortshow==true">
          <div v-for="(item,index) in short" :key="index">
            <div class="Tit">{{item.examTitle}}</div>
            <el-input type="textarea" v-model="ruleForm.short" placeholder="请输入正确答案"></el-input>
            <div class="send" @click="getTestItem(item.fid,ruleForm.short)">下一题</div>
          </div>
        </div>
        <div v-show="send">
          <div class="ans">请提交答案！</div>
          <div class="send" @click="getEnd()">提交</div>
        </div>
        <div v-show="Accuracy">
          <div class="ans">正确率：{{AccuracyText}}</div>
          <div class="sendgo">返回立体教材详情</div>
        </div>
        <!-- </el-form> -->
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
export default {
  data() {
    return {
      ruleForm: {
        single: '',
        judge: '',
        blanks: '',
        short: '',
        name: '',
        type: []
      },

      single: [],
      multiple: [],
      judge: [],
      blanks: [],
      short: [],
      singlesshow: false,
      multipleshow: false,
      judgeshow: false,
      blanksshow: false,
      shortshow: false,
      send: false,
      type: [],
      answerList: [],
      test: {
        chapterId: '',
        pageNum: 0,
        pageSize: 1
      },
      Accuracy: false,
      AccuracyText: ''
    }
  },
  created() {
    this.getTestItem()
  },
  methods: {
    async getTestItem(id, v) {
      let fid = this.$route.query.fid
      this.test.chapterId = fid
      this.test.pageNum++
      if (v instanceof Array) {
        var s = v.toString()
        v = s
      }
      if (this.test.pageNum > 1) {
        this.answerList.push({ fid: id, answer: v })
        console.log('答案', this.answerList)
        this.clear()
      }
      // console.log(this.test.pageNum)
      let res = await api.post(
        '/front/teamaterial/getChapterExamForWX',
        this.test
      )
      console.log(res)
      for (let i = 0; i < res.data.list.length; i++) {
        console.log(res.data.list[i].examType)
        if (res.data.list[i].examType == 0) {
          this.single.push(res.data.list[i])
          this.shortshow = true
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = false
          console.log(this.single)
          this.sentbut(res.data.isLastPage)
        } else if (res.data.list[i].examType == 1) {
          this.multiple.push(res.data.list[i])
          this.shortshow = false
          this.multipleshow = true
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.multiple)
        } else if (res.data.list[i].examType == 2) {
          this.judge.push(res.data.list[i])
          this.shortshow = false
          this.multipleshow = false
          this.judgeshow = true
          this.blanksshow = false
          this.shortshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.judge)
        } else if (res.data.list[i].examType == 3) {
          this.blanks.push(res.data.list[i])
          this.shortshow = false
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = true
          this.shortshow = false
          this.sentbut(res.data.isLastPage)
          console.log(this.blanks)
        } else {
          this.short.push(res.data.list[i])
          this.shortshow = false
          this.multipleshow = false
          this.judgeshow = false
          this.blanksshow = false
          this.shortshow = true
          this.sentbut(res.data.isLastPage)
          console.log(this.short)
        }
      }
    },
    clear() {
      this.single = []
      this.multiple = []
      this.judge = []
      this.blanks = []
      this.short = []
      this.ruleForm.single = ''
      this.ruleForm.judge = ''
      this.ruleForm.blanks = ''
      this.ruleForm.short = ''
      this.ruleForm.type = []
    },
    sentbut(last) {
      if (last == true) {
        this.send = true
      }
    },
    async getEnd() {
      let res = await api.post('/front/teamaterial/commitChapterExam', {
        chapterId: this.test.chapterId,
        answers: this.answerList
      })
      console.log(res)
      this.AccuracyText = res.data.accuracy
      this.send = false
      this.Accuracy = true
    }
  }
}
</script>
<style lang="scss" scoped>
.centest {
  margin: 0 auto;
  width: 940px;
  min-height: 600px;
  background: rgba(255, 255, 255, 1);
  padding: 30px 80px 0 80px;
  .testTit {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
    border-bottom: 1px solid #d2d2d2ff;
    // padding-bottom: 5px;
  }
  .testTip {
    padding-top: 20px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    line-height: 18px;
  }
  .send {
    width: 100px;
    height: 36px;
    background: #0082F0;
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 30px 0 0 0;
  }
  .sendgo {
    width: 160px;
    height: 36px;
    background: #0082F0;
    color: #fff;
    text-align: center;
    line-height: 36px;
    margin: 30px 0 0 0;
  }
}
.Tit {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 48px;
}
.ans {
  font-size: 38px;
  color: rgba(51, 51, 51, 1);
  line-height: 48px;
  margin: 50px 0 200px;
}
</style>
<style lang="scss">
.centest {
  .el-form-item__content {
    margin-left: 0 !important;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
  .el-form-item__label {
    float: none;
    padding-bottom: 10px;
  }
  .el-radio {
    display: block;
    height: 40px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #666666ff;
    border-color: #666666ff;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: rgba(51, 51, 51, 1);
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .icoLogo {
    margin-left: 8px;
  }
  .icoText {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
  .el-input {
    width: 480px;
  }
  .el-input__inner {
    border-radius: 0;
  }
  .el-textarea {
    width: 480px;
  }
  .el-textarea__inner {
    height: 200px !important;
  }
  .el-checkbox {
    width: 100%;
  }
}
</style>